/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

import {
    REQUEST_USER_ACCESS_MENU,
    REQUEST_USER_ACCESS_MENU_FAILURE,
    REQUEST_USER_ACCESS_MENU_SUCCESS
} from "../../constant/UserAccessMenuConstant";

const initialState = {
    userAccessMenu: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const userAccessMenuReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_USER_ACCESS_MENU:
            return {
                ...state,
                userAccessMenu: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_USER_ACCESS_MENU_SUCCESS:
            return {
                ...state,
                userAccessMenu: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_USER_ACCESS_MENU_FAILURE:
            return {
                ...state,
                userAccessMenu: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
